export default {
  // Endpoints
  REFRESH_TOKEN: '/api/token/refresh/',
  LOGIN: '/api/token/',
  VOICEMAIL_LIST: '/api/v3/voicemail',
  CALL_LIST: '/api/v3/callhistory',
  CLICK_TO_CALL: '/extensions/{id}/click-to-call/',
  SEND_FAX: '/faxes/',
  GROUPS: '/api/groups',
  THREADS: '/api/threads',
  GROUP_MESSAGE: '/api/messages',
  EXTENSIONS: '/extensions/',
  GET_PHONENUMBERS: '/api/phone_numbers',
  // New Endpoints
  GET_SNIPPETS: '/message-snippets/',
  MESSAGE_THREADS: '/message-threads/',
  MESSAGE_GROUPS: '/message-groups/',
  GET_MESSAGES: '/messages/',
  GET_PBXES: '/pbxes/',
  GET_PBX_USERS: '/users/select/',
  VOICEMAILS: '/voicemails/',
  FAXES: '/faxes/',
  PHONE_NUMBERS: '/phone-numbers/',
  CONTACTS: '/contacts/',
  CONTACT_SOURCES: '/contact-sources/',
  RECENT_CALLS: '/call-logs/',
  CALLS: '/calls/',
  CALL_TRANSCRIPTS: '/call-transcripts/',
  TRANSCRIBED_CALLS: '/call-transcripts-by-pbx/',
  CALL_TRANSCRIPT: '/call-transcripts-by-pbx/{pbxId}/entry/{callId}/',
  BLOCKED_NUMBERS: '/blocked-numbers/',
  QUEUE_AGENT_STATUS: '/extensions/{extensionId}/call-queues/agent/',
  QUEUE_LOG_IN: '/extensions/{extensionId}/call-queues/log-in/',
  QUEUE_LOG_OUT: '/extensions/{extensionId}/call-queues/log-out/',
  CALL_CENTER_AGENT_STATUS: '/app/v1/call-center-agent-status/',
  CALL_CENTER_USER_AGENT_EVENT_LOGS:
    '/app/v1/call-center-user-agent-event-logs/',
  CALL_CENTER_USER_AGENTS: '/app/v1/call-center-user-agents/',
  EXTENSIONS_SELECT: '/extensions/select/',
  REPORTING_CALLS: '/app/v1/reporting/calls/',
  // External links
  FEEDBACK:
    'https://docs.google.com/forms/d/e/1FAIpQLSfUejJyGSf-7vVwDlCYT66uz73FgAGb9fBg2V0zv_XEH0W94Q/viewform',
  CONTACTUS: 'https://mangovoice.com/contact/',
  SUPPORT: 'https://mangovoice.com/contact-support-ticket/',
  HELP_CENTER: 'https://support.mangovoice.com/',
  MMS_SUPPORT: 'https://support.mangovoice.com/',
  FAX_SUPPORT: 'https://support.mangovoice.com/',
  ADMIN: 'https://admin.mangovoice.com',
  FORGOT: 'https://admin.mangovoice.com/admin/account/forgotpassword',
  UPGRADE: 'https://mangovoice.com/upgrade/',
  DESKTOP_APP_DOWNLOAD: 'https://mangovoice.com/desktop-app/',
}
